import { Component, Input, ChangeDetectionStrategy, forwardRef, ChangeDetectorRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

export interface RadioOption {
  value: string;
  label: string;
  disabled?: boolean;
}

@Component({
  selector: 'hc-radio-group',
  templateUrl: './radio.component.html',
  styleUrls: ['./radio.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => HcRadioGroupComponent),
    multi: true
  }]
})
export class HcRadioGroupComponent implements ControlValueAccessor {
  @Input() options: RadioOption[] = [];
  @Input() name = '';
  @Input() disabled = false;
  @Input() hasError = false;
  @Input() inline = true; // horizontal by default

  value = '';

  private onChange: (value: string) => void = () => {};
  private onTouched: () => void = () => {};

  constructor(private cdr: ChangeDetectorRef) {}

  writeValue(value: string): void {
    this.value = value ?? '';
    this.cdr.markForCheck();
  }

  registerOnChange(fn: (value: string) => void): void { this.onChange = fn; }
  registerOnTouched(fn: () => void): void { this.onTouched = fn; }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
    this.cdr.markForCheck();
  }

  select(option: RadioOption): void {
    if (this.disabled || option.disabled) return;
    this.value = option.value;
    this.onChange(this.value);
    this.onTouched();
  }

  onKeydown(event: KeyboardEvent, option: RadioOption): void {
    if (event.key === ' ' || event.key === 'Enter') {
      event.preventDefault();
      this.select(option);
    }
  }
}
